import {Modal, InputNumber, Input, Row, Col} from 'antd';
import {useState} from 'react';
import {UserSelectWidget} from "../tasks/UserSelectWidget";

const {TextArea} = Input;

export const ResetMomModal = ({user, open, onOk, onCancel, max}) => {
    const [numDestroy, setNumDestroy] = useState(1);
    const [createdBy, setCreatedBy] = useState (user);
    const [notes, setNotes] = useState(undefined);

    const onChange = (val) => {
        setNumDestroy(val);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onModalOk = () => {
        if (onOk) {
            onOk(numDestroy, notes, createdBy);
        }
        clearForm();
    }

    const onModalCancel = () => {
        if (onCancel) onCancel();
        clearForm();
    }

    const clearForm = () => {
        setNotes(undefined);
        setCreatedBy(user);
    }

    const setUser = (val) => {
        setCreatedBy(val);
    }


    const rowStyle={
        marginTop: '5px',
        marginBottom: '10px',
    }

    return <Modal title={`Enter the Number of Plants to Reset as Mom`} open={open} onOk={onModalOk} onCancel={onModalCancel}>
        <Row style={rowStyle}>
        <InputNumber min={1} max={max} precision={0} disabled={true} onChange={onChange} value={numDestroy}/>
        </Row>
        <Row style={rowStyle}>
        <TextArea maxLength={512} rows={4} placeholder={`notes`} onChange={onNotesChange} value={notes}/>
        </Row>
        <Row style={rowStyle}>
            <Col span={6}>
                <b>Performed By:</b>
            </Col>
            <Col>
                <UserSelectWidget user={createdBy} setUser={setUser} />
            </Col>
        </Row>
    </Modal>
}